// src/layouts/AuthLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import TopNavbarBasic from '../components/NavbarBasic';

export default function AuthLayoutBasic() {
    // w-100 to fluid content
    // The d-flex class makes the container a flex containerallowing you to use other flex utilities
    //  and align its children (flex items like flex-row)
    // Container fluid - fluid prop sets its width to 100% across all viewport sizes
  return (
    <>
      <TopNavbarBasic />
      <div className="fluid align-items-center justify-content-center d-flex">
        <Outlet />
      </div>
    </>
  );
}
